import { injectBaseConstantMethods } from "./BaseConstants"

const SlotTypes = {
   REGULAR: "REGULAR",
   PREMIUM: "PREMIUM",
}

const displayTextKeys = {
   [SlotTypes.REGULAR]: "Regular",
   [SlotTypes.PREMIUM]: "Premium",
}

const labelClass = {}

export default injectBaseConstantMethods(SlotTypes, displayTextKeys, labelClass)
